import PropTypes from "prop-types";
import { Plus, X } from "lucide-react";

import { Button } from "./Button";
import { CustomTextField } from "./CustomTextField";
import { Label } from "./Label";
import { linksAreValid } from "../utils/linkLists";

const INVALID_URL_MESSAGE = "Introduce una URL válida (máximo 500 caracteres)";

export const LinkListEditor = ({
  value = [],
  onChange,
  disabled = false,
  label,
}) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%" }}>
    {label ? <Label>{label}</Label> : null}

    {value.map((url, index) => {
      const hasError = Boolean(url.trim()) && !linksAreValid([url]);

      return (
        <div
          key={index}
          style={{ display: "flex", alignItems: "flex-start", gap: 8, width: "100%" }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <CustomTextField
              value={url}
              disabled={disabled}
              placeholder="https://..."
              isUrlField
              error={hasError}
              errorMessage={hasError ? INVALID_URL_MESSAGE : ""}
              onChange={(event) =>
                onChange(
                  value.map((item, itemIndex) =>
                    itemIndex === index ? event.target.value : item
                  )
                )
              }
            />
          </div>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            disabled={disabled}
            aria-label={`Eliminar enlace ${index + 1}`}
            onClick={() => onChange(value.filter((_, itemIndex) => itemIndex !== index))}
          >
            <X size={18} />
          </Button>
        </div>
      );
    })}

    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={disabled}
      onClick={() => onChange([...value, ""])}
      sx={{ alignSelf: "flex-start" }}
    >
      <Plus size={16} />
      Añadir enlace
    </Button>
  </div>
);

LinkListEditor.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
};
